import { css } from "@emotion/core";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import React from "react";

const FlexaLogo = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "logos/flexa-logo@3x.png" }) {
        childImageSharp {
          fluid(maxWidth: 48) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <div
      css={css`
        width: var(--menu-height);
        height: var(--menu-height);

        & img {
          width: 100%;
        }
      `}
    >
      <Img fluid={data.placeholderImage.childImageSharp.fluid} />
    </div>
  );
};

export default FlexaLogo;
